import { OccConfig } from '@spartacus/core';

export const invoicesOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getInvoices: `/users/$\{userId}/invoices/search`,
        getInvoice: `/users/$\{userId}/invoices/details?uid=$\{uid}`,
        exportInvoices: `/users/$\{userId}/invoices/export`,
        exportInvoice: `/users/$\{userId}/invoices/details/export?uid=$\{uid}&fileType=$\{fileType}`,
      } as any,
    },
  },
};
